<template>
    <BasePageSrpPdf>
        <template v-slot:slot_general_info="slotprop_slot_general_info">
            <ComponentGeneralInfo 
            prop_pdf_display
            v-bind:prop_submission="slotprop_slot_general_info.submission"/>
        </template>
        <template v-slot:slot_media="slotprop_slot_media">
            <!-- DISABLE THE ALL MEDIA MODAL TO IMPROVE PDF SIZE AND PERFORMANCE-->
            <ComponentMedia 
            prop_show_modal_for_all="false"
            v-bind:prop_submission="slotprop_slot_media.submission"/>
        </template>
        <template v-slot:slot_services_summaries="slotprop_slot_services_summaries">
            <div class="row" id="ID-ROW-pdf-page-3">
                <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <h4 class="app-class-summary-panel-group-headings text-center">
                        <strong>SERVICE READINESS</strong>
                    </h4>
                    <v-row>
                        <v-col cols="6">
                            <ComponentSummary9 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary14 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary4 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary3 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                        <v-col cols="6">
                            <ComponentSummary1 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary8 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary11 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                    </v-row>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <h4 class="app-class-summary-panel-group-headings">
                        <strong>SERVICE DELIVERY</strong>
                    </h4>
                    <v-row>
                        <v-col cols="12">
                            <ComponentSummary2 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary12 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div class="row" id="ID-ROW-pdf-page-4">
                <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <h4 class="app-class-summary-panel-group-headings text-center">
                        <strong>MANAGEMENT AND GOVERNANCE</strong>
                    </h4>
                    <v-row>
                        <v-col cols="6">
                            <ComponentSummary6 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary5 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                        <v-col cols="6">
                            <ComponentSummary7 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                            <ComponentSummary10 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                    </v-row>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <h4 class="app-class-summary-panel-group-headings">
                        <strong>USER FEES</strong>
                    </h4>
                    <v-row>
                        <v-col cols="12">
                            <ComponentSummary13 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                    </v-row>
                    <h4 class="app-class-summary-panel-group-headings">
                        <strong>HUMAN RESOURCE FOR HEALTH</strong>
                    </h4>
                    <v-row>
                        <v-col cols="12">
                            <ComponentSummary15 
                            v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </template>
    </BasePageSrpPdf>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS

//MODULE COMPONENTS
import ComponentGeneralInfo from '@/views/module_addon_form_bhcpf/components/ComponentGeneralInfo';
import ComponentMedia from '@/views/module_addon_form_bhcpf/components/ComponentMedia';
import ComponentSummary1 from '@/views/module_addon_form_bhcpf/components/ComponentSummary1';
import ComponentSummary2 from '@/views/module_addon_form_bhcpf/components/ComponentSummary2';
import ComponentSummary3 from '@/views/module_addon_form_bhcpf/components/ComponentSummary3';
import ComponentSummary4 from '@/views/module_addon_form_bhcpf/components/ComponentSummary4';
import ComponentSummary5 from '@/views/module_addon_form_bhcpf/components/ComponentSummary5';
import ComponentSummary6 from '@/views/module_addon_form_bhcpf/components/ComponentSummary6';
import ComponentSummary7 from '@/views/module_addon_form_bhcpf/components/ComponentSummary7';
import ComponentSummary8 from '@/views/module_addon_form_bhcpf/components/ComponentSummary8';
import ComponentSummary9 from '@/views/module_addon_form_bhcpf/components/ComponentSummary9';
import ComponentSummary10 from '@/views/module_addon_form_bhcpf/components/ComponentSummary10';
import ComponentSummary11 from '@/views/module_addon_form_bhcpf/components/ComponentSummary11';
import ComponentSummary12 from '@/views/module_addon_form_bhcpf/components/ComponentSummary12';
import ComponentSummary13 from '@/views/module_addon_form_bhcpf/components/ComponentSummary13';
import ComponentSummary14 from '@/views/module_addon_form_bhcpf/components/ComponentSummary14';
import ComponentSummary15 from '@/views/module_addon_form_bhcpf/components/ComponentSummary15';

//BASE_PAGE
import BasePageSrpPdf from '@/views/base_pages/BasePageSrpPdf';

//########################################
//CONST AND VARS
//########################################

//########################################
//MAIN
//########################################

export default {
    name: 'ModuleBhcpfPageSrpPdf',

    components: {
        //BASE PAGE
        BasePageSrpPdf,

        //GENERIC COMPONENTS

        //MODULE COMPONENTS
        ComponentGeneralInfo,
        ComponentMedia,
        ComponentSummary1,
        ComponentSummary2,
        ComponentSummary3,
        ComponentSummary4,
        ComponentSummary5,
        ComponentSummary6,
        ComponentSummary7,
        ComponentSummary8,
        ComponentSummary9,
        ComponentSummary10,
        ComponentSummary11,
        ComponentSummary12,
        ComponentSummary13,
        ComponentSummary14,
        ComponentSummary15,
    },
};
</script>
